import { Icon } from '../../ui/Icon'
import { templateLook, type StaffNotification } from './model'

/** Больше карточек разом не показываем: остальные — одной строкой «ещё N». */
export const POPUPS_SHOWN = 3

export interface NotificationPopupsProps {
  /** Свежие сверху. */
  items: readonly StaffNotification[]
  onOpen: (notification: StaffNotification) => void
  onClose: (notification: StaffNotification) => void
  /** «Ещё N» — в список, все карточки уходят. */
  onAll: () => void
}

/**
 * Новые уведомления в открытой вкладке: карточки в правом верхнем углу. Сами
 * не уходят — только по «Открыть» или крестику, чтобы заказ не прошёл мимо.
 */
export function NotificationPopups({ items, onOpen, onClose, onAll }: NotificationPopupsProps) {
  if (items.length === 0) return null
  const hidden = items.length - POPUPS_SHOWN
  return (
    <section className="nt-pops" aria-label="Новые уведомления">
      {items.slice(0, POPUPS_SHOWN).map((n) => {
        const look = templateLook(n.template)
        return (
          <article key={n.id} className="nt-pop" data-tone={look.tone} role="alert">
            <span className="nt-icon" data-tone={look.tone} title={look.label} aria-hidden="true">
              <Icon name={look.icon} />
            </span>
            <div className="nt-pop-txt">
              <b>
                <span className="visually-hidden">{look.label}: </span>
                {n.title}
              </b>
              {n.body ? <span className="nt-pop-body">{n.body}</span> : null}
            </div>
            <button
              type="button"
              className="ui-btn"
              data-size="sm"
              onClick={() => {
                onOpen(n)
              }}
            >
              {n.orderId ? 'Открыть заказ' : 'Открыть'}
            </button>
            <button
              type="button"
              className="ui-iconbtn nt-pop-close"
              aria-label="Закрыть уведомление"
              onClick={() => {
                onClose(n)
              }}
            >
              <Icon name="i-x" />
            </button>
          </article>
        )
      })}
      {hidden > 0 ? (
        <button
          type="button"
          className="ui-btn nt-pop-more"
          data-variant="secondary"
          onClick={onAll}
        >
          Ещё {hidden} — все уведомления
        </button>
      ) : null}
    </section>
  )
}
